import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Swal from 'sweetalert2';
import { listStudents } from '../actions/studentActions';
import { detailsCourse } from '../actions/courseActions';
import { getNotificationsUser, sendNotificationParent } from '../actions/notificationActions';
import { AlertMessage } from '../components/AlertMessage';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar'
import { CustomDataTable } from '../components/CustomDataTable';
import removeAccents from '../utils/removeAccents';
import { Link } from 'react-router-dom';

export const AbsencesCourseScreen = () => {
    const params = useParams();
    const { id: courseId } = params;

    const modalCancelButton = useRef(null)

    const { loading, error, students } = useSelector(state => state.studentList);
    const [studentsCourse, setStudentsCourse] = useState([]);
    const [sendingNotification, setsendingNotification] = useState(false)
    const [selectedUsers, setSelectedUsers] = useState([])
    const [message, setMessage] = useState('')

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(detailsCourse(courseId));
        dispatch(listStudents())
        dispatch(getNotificationsUser());
    }, [dispatch, courseId])

    useEffect(() => {
        if(students){
            setStudentsCourse(students?.filter(student => student.course._id === courseId))
        }
    }, [students, courseId])

    const pushNotificationHandler = async(e) => {
        e.preventDefault();
        if (selectedUsers.length > 0) {
            setsendingNotification(true)
            selectedUsers.forEach((user, index) => {
                dispatch(sendNotificationParent(user, message))
                    if (index === selectedUsers.length - 1) {
                        setsendingNotification(false)
                        Swal.fire({
                            position: 'center',
                            iconHtml: '<img src="/success.svg" class="mt-5">',
                            html: '<p class="mb-7 mt-10 fw-bolder fs-2">Ausencias enviadas</p><p>Las ausencias de los alumnos de hoy han sido enviadas a sus tutores/as correctamente.</p>',
                            showConfirmButton: false,
                            timer: 3500,
                            showConfirmButton: true,
                            confirmButtonText: "Aceptar"
                        })
                    }
            })
            modalCancelButton.current.click()
        }

        setSelectedUsers([]);
        setMessage('');
    }

    const addUser = async(e, idStudent) => {
        if (e.target.checked) {
            setSelectedUsers([...selectedUsers, idStudent])
        }else{
            setSelectedUsers(selectedUsers?.filter(student => student !== idStudent))
        }
    }

    const columns = [
        {
            name: 'Alumno',
            selector: (row) => removeAccents(row.name),
            cell: (row) => row.name,
            sortable: true,
        },{
            name: 'Ausente',
            selector: (row) => removeAccents(row.name),
            cell: (row) => 
                <div className="fv-row">
                    <label className='form-check form-switch form-check-custom form-check-solid'>
                        <input className='form-check-input h-20px w-30px' type='checkbox' onClick={e => addUser(e, row._id)}/>
                    </label>
                </div>
            ,
            sortable: true,
        }
    ];

    return (
        <>
            <ToolBar titulo={"Alumnos"} hitos={[
                { titulo: "Colegio", enlace: "/courselist" },
                { titulo: "Cursos", enlace: "/" },
            ]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    {loading ? (<LoadingBox variant={"primary"} />) :
                        error ? (<AlertMessage variant={"danger"} message={error} />) : (
                            <div className="card card-flush">
                                <div className="card-body">
                                    <div className="text-start my-10">
                                        <Link to="/courselist">
                                            <div className='d-flex align-items-center mb-1'>
                                                <img src='/arrow-left.svg' className='me-3' alt='Flecha izquierda'/>
                                                <h2 className="text-primary fs-1 mb-0">Listado de Alumnos</h2>
                                            </div>
                                        </Link>
                                        <div className='separator'/>
                                    </div>
                                    <CustomDataTable pagination data={studentsCourse} columns={columns} />
                                    {/* <div className="mb-10 fv-row">
                                        <label className="form-label">Mensaje de la ausencia: </label>
                                        <textarea className="form-control mb-3" rows="5" data-kt-element="input" value={message || ''} onChange={(e) => setMessage(e.target.value)}></textarea>
                                    </div> */}
                                    <div className='d-flex justify-content-end mt-10'>
                                        <div className='w-75 row'>
                                            <div className='col-6 d-grid'>
                                                <Link to="/courselist" className="btn btn-lg btn-outline-dark border border-dark rounded-pill py-5">Cancelar</Link>
                                            </div>
                                            <div className='col-6 d-grid'>
                                                <button type="button" className="btn btn-lg btn-primary rounded-pill py-5" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                                    {sendingNotification ? (<LoadingBox variant={"primary"}/>)
                                                    :
                                                    (<span className="indicator-label">Notificar ausencias</span>)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>
            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <div className="text-start w-100">
                                <div className='d-flex align-items-center mb-1'>
                                    <h2 className="text-primary fs-1 mb-0">Notificar Ausencias</h2>
                                </div>
                                <div className='separator'/>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className='mb-10'>
                                <div className='fv-row'>
                                    <label className="form-label">Mensaje para sus tutores/as</label>
                                    <textarea className="form-control mb-3" rows="7" data-kt-element="input" value={message || ''} onChange={(e) => setMessage(e.target.value)} placeholder='Escribe tu mensaje...'></textarea>
                                </div>
                            </div>
                            <div className='d-flex justify-content-end mt-10 mb-5'>
                                <div className='w-75 row'>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-outline-dark border border-dark rounded-pill py-5" data-bs-dismiss="modal" ref={modalCancelButton}>Cancelar</button>
                                    </div>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-primary rounded-pill py-5" onClick={pushNotificationHandler}>Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}